import { type ComponentType, type JSX, type ReactNode } from "react"

import { type PlanAccess } from "@forento/core/models/payment"

import Layout from "~/components/Layout"
import LockedFeature from "~/components/LockedFeature"
import { useUser } from "~/contexts/UserContext"

export default function withAccessRequirement<T extends JSX.IntrinsicAttributes>(
	access: PlanAccess,
	header: ReactNode,
	WrappedComponent: ComponentType<T>,
): ComponentType<T> {
	return props => {
		const platform = useUser().user!.platform!

		if (!platform.plan.access[access])
			return (
				<Layout>
					{header}
					<LockedFeature />
				</Layout>
			)

		return <WrappedComponent {...props} />
	}
}
